import { AplicacaoMonitoramento } from './aplicacao-monitoramento.model';
import { AtivoMonitoramentoDetalhado } from './ativo-monitoramento-detalhado.model copy';
import { ItemMonitoramentoDetalhado } from './item-monitoramento-detalhado.model';
import { ItemMonitoramento, SituacaoMonitoramento } from './item-monitoramento.model';

export class AplicacaoMonitoramentoDetalhado<E extends AplicacaoMonitoramento> {

  public monitoramento: E;
  public carregando = false;
  public ativos: AtivoMonitoramentoDetalhado[] = [];

  constructor(public nome: string) {}

  atualizar(monitoramento: E, ativos: AtivoMonitoramentoDetalhado[]): void {
    this.monitoramento = monitoramento;
    this.ativos = ativos;
    this.carregando = false;
  }

  atualizarComErro(erro: string): void {
    this.monitoramento = undefined;
    this.ativos = [
      new AtivoMonitoramentoDetalhado('Monitoramento', [
        new ItemMonitoramentoDetalhado('Acesso', new ItemMonitoramento(SituacaoMonitoramento.FALHA, erro))
      ])
    ];
    this.carregando = false;
  }

  public isSituacaoSucesso(): boolean {
    return this.ativos.filter(ativo => ativo.isFalha()).length === 0;
  }

  public isSituacaoFalha(): boolean {
    return !this.isSituacaoSucesso();
  }

  public getFalhasDescricao(): string {
    return this.ativos.filter(ativo => ativo.isFalha()).map(ativo => ativo.getFalhasDescricao()).join('<br/>');
  }
}

